<template>
    <div id="header">
        <div class="content clearfix inner">
            <div class="left fl">
                <img class="logo" :src="imgSrc" alt="">
            </div>
            <!-- <div class="right fr">
                <div @click="showBox">
                    <a href="JavaScript:;">搜 索 |</a>
                    <a href="JavaScript:;">登 录 |</a>
                    <a href="JavaScript:;">注 册</a>
                </div>
                <a href="javascript:;" ref="ahref" @click="intoIndex" class="goIndex" :class="{'esstyle':title=='发布二手' || '发布房产'}">{{title}}</a>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    props:['title','imgSrc'],
    data() {
        return {
            showBtn:true
        }
    },
    created() {
        
    },
    methods:{
        showBox() {
            this.$emit('func',this.showBtn)
        },
        intoIndex() {
            if(this.title == '回到首页') {
                this.$refs.ahref.setAttribute('href','http://www.wangjing.cn')
                this.$refs.ahref.setAttribute("target","_blank")

            }else{
                this.showBox()
            }
        }
    }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
    #header{
        .content{
            padding:18px 100px 14px;
            .left {
                .logo{
                    margin-top:10px;
                    width:196px;
                }
            }
            .right{
                a{
                    font-size:@ft18;
                    color:@fc32;
                }
                .goIndex{
                    font-weight: 540;
                    color:#000;
                    display: inline-block;
                    margin:12px 0 0 45px;
                }
                .esstyle{
                    background: #95c847;
                    color: #fff;
                    border: 0;
                    padding:3px 5px;
                    border-radius:5px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue